/**
 * @generated SignedSource<<67edb387938231e693b7487423487080>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BundleStatus = "CANCELLED" | "COLLECTED" | "CONFIRMED" | "FORMING" | "PARTIALLY_COLLECTED" | "READY_FOR_PICKUP" | "%future added value";
export type CreditSubscriptionStatus = "ACTIVE" | "CANCELED" | "INCOMPLETE" | "INCOMPLETE_EXPIRED" | "PAST_DUE" | "PAUSED" | "TRIALING" | "UNPAID" | "%future added value";
export type oneDeliveryShipmentsQuery$variables = {
  statuses: ReadonlyArray<BundleStatus>;
  userId: string;
};
export type oneDeliveryShipmentsQuery$data = {
  readonly bundles: {
    readonly nodes: ReadonlyArray<{
      readonly createdAt: any;
      readonly hub: {
        readonly id: string;
        readonly meta: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly packages: {
        readonly totalCount: number;
      };
      readonly status: BundleStatus;
      readonly warehouse: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly creditBalance: {
    readonly available: number;
  };
  readonly creditSubscription: {
    readonly cancelAtPeriodEnd: boolean;
    readonly currentPeriodEnd: any | null | undefined;
    readonly id: string;
    readonly plan: {
      readonly credits: number;
      readonly id: string;
      readonly title: string;
    };
    readonly status: CreditSubscriptionStatus;
  } | null | undefined;
};
export type oneDeliveryShipmentsQuery = {
  response: oneDeliveryShipmentsQuery$data;
  variables: oneDeliveryShipmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statuses"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 100
  }
},
v5 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditBalance",
    "kind": "LinkedField",
    "name": "creditBalance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "available",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditSubscription",
    "kind": "LinkedField",
    "name": "creditSubscription",
    "plural": false,
    "selections": [
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelAtPeriodEnd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentPeriodEnd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CreditPlan",
        "kind": "LinkedField",
        "name": "plan",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "credits",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "statuses",
            "variableName": "statuses"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      (v4/*:: as any*/)
    ],
    "concreteType": "BundlePage",
    "kind": "LinkedField",
    "name": "bundles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Bundle",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Warehouse",
            "kind": "LinkedField",
            "name": "warehouse",
            "plural": false,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HubMeta",
                "kind": "LinkedField",
                "name": "meta",
                "plural": false,
                "selections": (v5/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v4/*:: as any*/)
            ],
            "concreteType": "PackagePage",
            "kind": "LinkedField",
            "name": "packages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": "packages(pagination:{\"page\":0,\"pageSize\":100})"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "oneDeliveryShipmentsQuery",
    "selections": (v6/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "oneDeliveryShipmentsQuery",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "cacheID": "992ddaf66e1ce7c09857aea81e2c217f",
    "id": null,
    "metadata": {},
    "name": "oneDeliveryShipmentsQuery",
    "operationKind": "query",
    "text": "query oneDeliveryShipmentsQuery(\n  $userId: UUID!\n  $statuses: [BundleStatus!]!\n) {\n  creditBalance {\n    available\n  }\n  creditSubscription {\n    id\n    status\n    cancelAtPeriodEnd\n    currentPeriodEnd\n    plan {\n      id\n      title\n      credits\n    }\n  }\n  bundles(filter: {userId: $userId, statuses: $statuses}, pagination: {page: 0, pageSize: 100}) {\n    nodes {\n      id\n      status\n      createdAt\n      warehouse {\n        id\n        name\n      }\n      hub {\n        id\n        meta {\n          id\n          name\n        }\n      }\n      packages(pagination: {page: 0, pageSize: 100}) {\n        totalCount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9881bf90c368842912b4194f70c8ccc0";

export default node;
